import React from 'react'
import { useBox } from '@react-three/cannon'

const Wall = ({ position, rotation, args, color }) => {
  const [ref] = useBox(() => ({
    type: 'Static',
    position,
    rotation,
    args,
  }))
  return (
    <mesh ref={ref} position={position} rotation={rotation}>
      <boxGeometry args={args} />
      <meshBasicMaterial color={color} />
    </mesh>
  )
}

const Trim = ({ position, rotation, args }) => (
  <mesh position={position} rotation={rotation}>
    <boxGeometry args={args} />
    <meshBasicMaterial color='#555555' />
  </mesh>
)

const TRIM = 0.015
const ROOM_H = 20

const Walls = () => {
  return (
    <>
      {/* walls */}
      <Wall position={[0, 10, -20]} args={[182, 20, 0.001]} color='#e8e8e8' />
      <Wall position={[0, 10, 30]} args={[182, 20, 10]} color='#e8e8e8' />
      <Wall
        position={[-20, 10, 0]}
        rotation={[0, Math.PI / 2, 0]}
        args={[50, 20, 0.001]}
        color='#e8e8e8'
      />
      <Wall
        position={[90, 10, 0]}
        rotation={[0, Math.PI / 2, 0]}
        args={[50, 20, 0.001]}
        color='#e8e8e8'
      />
      <Wall
        position={[0, 12, 0]}
        rotation={[Math.PI / 2, 0, 0]}
        args={[182, 50, 0.001]}
        color='#b0b0b0'
      />

      {/* vertical corner strips */}
      <Trim position={[-20, 10, -20]} args={[TRIM, ROOM_H, TRIM]} />
      <Trim position={[90, 10, -20]} args={[TRIM, ROOM_H, TRIM]} />
      <Trim position={[-20, 10, 25]} args={[TRIM, ROOM_H, TRIM]} />
      <Trim position={[90, 10, 25]} args={[TRIM, ROOM_H, TRIM]} />
    </>
  )
}

export default Walls
